import { useMutation } from '@tanstack/react-query';

import { triageEmail } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useTriageEmail() {
  return useMutation({
    mutationFn: ({ documentId, link }: { documentId: string; link: string }) =>
      triageEmail(
        {
          body: {
            document_id: documentId,
            link,
          },
        },
        wgApi,
      ),
  });
}
